<template>
  <div class="contract-page">
    <div class="contract-container">
      <div class="title-bg">箱子码</div>
      <v-card class="form-card">
        <v-card-text>
          <v-row class="align-center">
            <v-col cols="12" sm="4">
              <v-text-field
                v-model.number="count"
                label="生成数量"
                type="number"
                persistent-placeholder
                variant="outlined"
                hide-details
                density="compact"
                class="search-input"
                placeholder="请输入生成数量"
                min="1"
                @keyup.enter="handleGenerate"
              />
            </v-col>
            <v-col cols="12" sm="5">
              <v-btn
                color="primary"
                variant="flat"
                @click="handleGenerate"
                class="search-btn"
                density="comfortable"
                :loading="loading"
              >
                生成并打印
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'
import { shipmentApi } from '@/services/api'
import { printBoxCodesBrowser } from '@/utils/boxCodeBrowserPrint'

const { showSuccess, showError } = useSnackbar()

const count = ref<number | null>(null)
const loading = ref(false)

const handleGenerate = async () => {
  if (!count.value || count.value < 1) {
    showError('请输入有效的生成数量')
    return
  }
  if (count.value > 1000) {
    showError('生成数量不能超过 1000')
    return
  }

  try {
    loading.value = true
    const res: any = await shipmentApi.generateBoxCodes({ count: count.value })
    if (res.code !== 0) {
      showError(res.msg || res.message || '生成失败')
      return
    }

    const codes: string[] = res.data || []
    if (codes.length === 0) {
      showError('未返回箱子码')
      return
    }
    /* 打印会等到 afterprint 才 resolve，勿 await，否则按钮 loading 会一直转到关闭预览 */
    void printBoxCodesBrowser(codes)
      .then(() => {
        //showSuccess('已打开打印预览')
      })
      .catch((err: unknown) => {
        console.error('箱子码打印失败:', err)
        showError(err instanceof Error ? err.message : '打印失败，请重试')
      })
  } catch (error: any) {
    console.error('生成箱子码失败:', error)
    showError(error.message || '生成失败，请重试')
  } finally {
    loading.value = false
  }
}
</script>

<style lang="scss" scoped>
.contract-page {
  min-height: 100vh;
  width: 100%;
  background-color: #2B2D33;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 16px;
}

.contract-container {
  width: 100%;
  max-width: 1400px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-card {
  background-color: #2B2D33 !important;
  border: none !important;
}

.form-card :deep(.v-text-field) .v-field__input,
.form-card :deep(.v-text-field) .v-field__field,
.form-card :deep(.v-text-field) input {
  color: #fff !important;
}

.form-card :deep(.v-text-field) .v-field__outline {
  color: rgba(255, 255, 255, 0.12) !important;
}

.form-card :deep(.v-text-field) .v-field__input::placeholder {
  color: rgba(255, 255, 255, 0.7) !important;
}

.form-card :deep(.v-text-field) .v-label {
  color: rgba(255, 255, 255, 0.7) !important;
}

.search-input {
  width: 100%;
}

.search-btn {
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0;
  font-size: 14px;
  padding: 0 16px;
  min-width: unset;
}

:deep(.v-card) {
  box-shadow: none !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
}
</style>
